import { useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import RequireAuth from '../requireAuth';
import DashboardHeader from '../dashboardHeader';
import { goLivePath, urgentMessagesDashboardPath } from '../../../constants';
import Card from '../../../components/dashboard/card';
import { faRss, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

const Properties = () => {
    const theme = useTheme();
    const navigate = useNavigate();

    const mainStyle = {
        fontFamily: theme.typography.fontFamily,
        backgroundColor: theme.palette.brand.linen,
        paddingTop: 'var(--nav-height)',
        minHeight: '100vh',
        boxSizing: 'border-box',
    };

    const eyebrowStyle = {
        fontFamily: theme.typography.fontFamily,
        fontSize: '12px',
        fontWeight: 700,
        letterSpacing: '0.12em',
        textTransform: 'uppercase',
        color: theme.palette.brand.brass,
        margin: '0 0 6px',
    };

    return (
        <div style={mainStyle}>
            <RequireAuth />

            <div style={{ maxWidth: '900px', margin: '0 auto', padding: '36px 24px 56px' }}>
                <DashboardHeader eyebrow="Manage" heading="Properties" showBackLink />

                <div style={eyebrowStyle}>Actions</div>
                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
                        gap: '10px',
                        marginTop: '12px',
                    }}
                >
                    <div onClick={() => navigate(goLivePath)} style={{ cursor: 'pointer' }}>
                        <Card
                            icon={faRss}
                            title="Live Feed Settings"
                            description="Update live feed status, link, and more"
                        />
                    </div>
                    <div onClick={() => navigate(urgentMessagesDashboardPath)} style={{ cursor: 'pointer' }}>
                        <Card
                            icon={faTriangleExclamation}
                            title="Urgent Messages"
                            description="Post, edit, and delete urgent messages for BBC guests"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Properties;
